// Actions
export const LOGIN_REQUEST: string = "Auth/LOGIN_REQUEST";
export const LOGIN_SUCCESS: string = "Auth/LOGIN_SUCCESS";
export const LOGIN_FAILURE: string = "Auth/LOGIN_FAILURE";

export const LOGOUT: string = "Auth/LOGOUT";

export const USER_INDEX_REQUEST: string = "Auth/Users/INDEX_REQUEST";
export const USER_INDEX_SUCCESS: string = "Auth/Users/INDEX_SUCCESS";
export const USER_INDEX_FAILURE: string = "Auth/Users/INDEX_FAILURE";

export const USER_STORE_REQUEST: string = "Auth/Users/STORE_REQUEST";
export const USER_STORE_SUCCESS: string = "Auth/Users/STORE_SUCCESS";
export const USER_STORE_FAILURE: string = "Auth/Users/STORE_FAILURE";

export const USER_SHOW_REQUEST: string = "Auth/Users/SHOW_REQUEST";
export const USER_SHOW_SUCCESS: string = "Auth/Users/SHOW_SUCCESS";
export const USER_SHOW_FAILURE: string = "Auth/Users/SHOW_FAILURE";

export const USER_UPDATE_REQUEST: string = "Auth/Users/UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS: string = "Auth/Users/UPDATE_SUCCESS";
export const USER_UPDATE_FAILURE: string = "Auth/Users/UPDATE_FAILURE";

export const USER_DESTROY_REQUEST: string = "Auth/Users/DESTROY_REQUEST";
export const USER_DESTROY_SUCCESS: string = "Auth/Users/DESTROY_SUCCESS";
export const USER_DESTROY_FAILURE: string = "Auth/Users/DESTROY_FAILURE";

export const ORGANISATION_INDEX_REQUEST: string = "Auth/Organisations/INDEX_REQUEST";
export const ORGANISATION_INDEX_SUCCESS: string = "Auth/Organisations/INDEX_SUCCESS";
export const ORGANISATION_INDEX_FAILURE: string = "Auth/Organisations/INDEX_FAILURE";

export const ROLE_INDEX_REQUEST: string = "Auth/Roles/INDEX_REQUEST";
export const ROLE_INDEX_SUCCESS: string = "Auth/Roles/INDEX_SUCCESS";
export const ROLE_INDEX_FAILURE: string = "Auth/Roles/INDEX_FAILURE";
